import React from 'react';
import {useDispatch} from "react-redux";
import {agreeServiceOfTerms} from "../../modules/User/actions";

const ServiceOfTerms = (props) => {
    const dispatch = useDispatch();

    return (
        <div className="p-grid__terms">
            <h2 id="transition-modal-title">■投稿に関する注意事項</h2>
            <p id="transition-modal-description">
                以下の注意事項をよく読んで、投稿ください。
            </p>
            <ol>
                <li>他人が不快になる内容でないこと。</li>
                <li>他人の財産、プライバシー等を侵害するものでないこと。</li>
                <li>犯罪に結びつく、または助長させるものでないこと。</li>
                <li>暴言、卑猥な表現等、公序良俗に反するものでないこと。</li>
                <li>他人の名誉を毀損し、または他人を誹謗中傷するものでないこと。</li>
                <li>著作権など知的財産権を侵害しないこと。</li>
                <li>法令等に反するものでないこと。</li>
                <li>投稿時に記載された情報は、弊社広報活動に活用させていただくため、二次利用（複製・編集・上映・頒布）させていただく場合があります。</li>
                <li>投稿時に記載された情報は、本サービスにおいてのみ利用し、本人の同意なくその他の目的で利用し、開示・公表することはありません。</li>
                <li>管理者は、上記注意事項に反していると判断したときは、又は投稿を削除する場合があります。</li>
                <li>投稿者は、上記注意事項を承諾のうえ、投稿をお願いします。</li>
            </ol>
            <div>
                <input type={"checkbox"} id={"agree-box"}/>
                <label htmlFor={"agree-box"}> 利用規約に同意する</label>
            </div>
            <button className="c-btn-primary" onClick={() => {
                if (document.getElementById("agree-box").checked) {
                    dispatch(agreeServiceOfTerms());
                    props.handleInputArea(true)
                } else {
                    alert('利用規約への同意が必要です。')
                }
            }}>同意する
            </button>
        </div>
    );
};

export default ServiceOfTerms;